import { Fragment, useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/GridLegacy";
import dynamic from "next/dynamic"
import { useCategoryContext } from "@components/Components/Providers/CategoryContext";

const CategoryFiltersMenuButton = dynamic(() => import("./CategoryFiltersMenuButton"), {
    loading: () => (
        <>
            <Skeleton animation="wave" variant="rectangle" sx={{ float: 'right', borderRadius: '4px', width: '150px', height: '40px' }} />
        </>
    ),
    ssr: true
});
const CategoryFiltersMenu = dynamic(() => import("./CategoryFiltersMenu"), {
    ssr: true
});

const CategoryFiltersAndMenu = (props) => {
    const { available_filters } = useCategoryContext();

    const [isFilterNestedMenuOpen, setToggleFilterNestedMenu] = useState({});
    const [toggleFiltersMenu, setToggleFiltersMenu] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    useEffect(() => {
        //check to see if the filters are an array or object.
        //if the filters are an array then there are no filters available to show
        // therefore the length will equal a num instead of undefined
        if (typeof available_filters.length == 'undefined') {
            setShowFilters(true)
        }
        return () => {
            setShowFilters(false)
        }
    }, [])


    //toggle the side filter menu
    const toggleSideFilterMenu = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        //map through the keys and set the initial state (open) to true
        let filter_obj = {};
        Object.keys(available_filters).map((key) => {
            filter_obj = {
                ...filter_obj,
                [key]: true
            }
        })
        setToggleFilterNestedMenu(filter_obj);
        setToggleFiltersMenu(open);
    };

    //collapse and expand the filter type
    const handleFilterNestedMenuClick = (filter_type) => {
        setToggleFilterNestedMenu((prevState) => ({
            ...prevState,
            [filter_type]: !prevState[filter_type],
        }));
    };

    return (
        <Grid sx={{ marginTop: 'auto' }} item xs={8}>
            {available_filters && showFilters &&
                Object.keys(available_filters).length > 0 && (
                    <Fragment>
                        <CategoryFiltersMenuButton
                            toggleSideFilterMenu={toggleSideFilterMenu}
                        />
                        <CategoryFiltersMenu
                            toggleFiltersMenu={toggleFiltersMenu}
                            isFilterNestedMenuOpen={isFilterNestedMenuOpen}
                            toggleSideFilterMenu={toggleSideFilterMenu}
                            handleFilterNestedMenuClick={handleFilterNestedMenuClick}
                        />
                    </Fragment>
                )
            }
        </Grid>
    )
}

export default CategoryFiltersAndMenu